import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  shape: 'rectangle'
} satisfies RecursivePartial<ProductConfig['swatches']>
